var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashFilter4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.343,
    height: 30.629,
    viewBox: "0 0 64.343 30.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2766",
    "data-name": "Group 2766",
    transform: "translate(-3075.268 298.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2765",
    "data-name": "Group 2765",
    transform: "translate(-32.6 -554)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 4.339,
    cy: 4.339,
    r: 4.339,
    transform: "translate(3113.961 277.128)",
    fill: "none",
    stroke: "",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.341
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 4.339,
    cy: 4.339,
    r: 4.339,
    transform: "translate(3157.351 277.128)",
    fill: "none",
    stroke: "",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.341
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M3122.639,281.467h24.949V256.518h-39.05v24.949h5.424",
    fill: "none",
    stroke: "",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.341
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M3166.029,281.467h5.424V268.549l-7.593-12.031h-16.271v24.949h9.763",
    fill: "none",
    stroke: "",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.341
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M3156.053,256.518v10.3l15.4,2.169",
    fill: "none",
    stroke: "",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.341
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashFilter4);
export default __webpack_public_path__ + "static/media/dash-filter-4.6aa2dbb42065d01bc47e52a65dd1eadd.svg";
export { ForwardRef as ReactComponent };